<template>
  <div id="app">
    <admin-header-item @logout="headerLogout"/>
    <main class="main">
      <router-view/>
    </main>
    <admin-footer-item/>
  </div>
</template>

<script>
import AdminHeaderItem from './components/HeaderItem'
import AdminFooterItem from './components/FooterItem'
import { SU, SessionKey } from './utils/session_utils'
import { CF } from './utils/common_func'
// import 'whatwg-fetch'
export default {
  components: {
    AdminFooterItem,
    AdminHeaderItem
  },
  metaInfo: () => (CF.metaInfo),
  created: function () {
    if (typeof window.fetch === 'undefined') {
      window.fetch = fetch
    }
    if (SU.getSessionValue(SessionKey.language)) {
      this.$store.dispatch('commitLanguage', SU.getSessionValue(SessionKey.language))
    } else {
      SU.saveSession(SessionKey.language, 'ja')
      this.$store.dispatch('commitLanguage', 'ja')
    }
    if (SU.getSessionValue(SessionKey.score)) {
      this.$store.dispatch('commitScore', SU.getSessionValue(SessionKey.score))
    } else {
      SU.saveSession(SessionKey.score, 'age')
      this.$store.dispatch('commitScore', 'age')
    }
  },
  methods: {
    headerLogout: function () {
      SU.clearSessions()
      this.$store.dispatch('commitUserData', null)
      this.$router.push({ name: 'member_login' })
    }
  }
}
</script>

<style lang="scss">
  @use "assets/scss/style" as g;
  html {
    font-size: 62.5%;
  }
  body {
    position: relative;
    font-size: 1.6rem;
    color: #383735;
    margin: 0;
    & * {
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }
  }

  main {
    display: block;
    min-height: calc(100vh - 18.6rem);
  }

  p {
    margin: 0;
  }

  a {
    text-decoration: none;
    opacity: 1;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    &:hover {
      opacity: 0.5;
    }
  }

  dl,
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  dd { margin: 0; }

  img {
    height: auto;
    max-width: 100%;
  }

  table {
    max-width: 100%;
    border-collapse: collapse;
    word-break: break-word;
  }

  figure {
    margin: 0;
  }

  input,
  select {
    font-size: 16px;
  }

  @for $i from 1 through 6 {
    h#{$i} {
      font-size: 1.4rem;
      font-weight: normal;
      margin: 0;
    }
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .pc_only {
    @include g.mediaMobile {
      display: none;
    }
  }
  .mobile_only {
    @include g.mediaPc {
      display: none;
    }
  }
  .dg-btn--ok {
    border-color: g.$darkGreen02;
  }
</style>
